import * as React from "react";
import {cx} from "emotion";

import "./mobile-control-panel.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";

import {OnGlobalKeyDownEnter} from "../../../../browser/global-key-down-enter";

export const MobileControlPanel = (
    {
        content, fullView=false, ready=true,
        extraAction=undefined,
        onDone=undefined, onCancel,
    }
) => cs(
    () => (
        <div {...{
            className: cx("mobile-control-panel-3ed", {fullView}),
            "xd-qa-type": "card",
            "xd-qa-name": "Control Panel",
        }}>

            <div className="top">
                <div className="left">
                    <button {...{
                        className: "cancel",
                        onClick: onCancel,
                        "xd-qa-type": "button",
                        "xd-qa-name": "Cancel",
                    }}>
                        <i className="fa fa-chevron-left"/>
                        Cancel
                    </button>
                </div>

                <div className="right">
                    {extraAction && (
                        <button {...{
                            className: "extra-action",
                            onClick: extraAction.onClick,
                        }}>
                            <i className={cx("fa", extraAction.icon)}/>
                            {extraAction.text}
                        </button>
                    )}
                    {onDone && (
                        <button {...{
                            className: "save",
                            disabled: !ready,
                            onClick: () => onDone(),
                            "xd-qa-type": "button",
                            "xd-qa-name": "Done",
                        }}>
                            <i className="fa fa-check"/>
                            Done
                        </button>
                    )}
                </div>
            </div>

            <div className="content">
                {content}
            </div>
        </div>
    ),
);
